module.exports = __webpack_public_path__ + "static/media/user-menu.937b9624.svg";